import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function historyPushState(type, val) {
    const url = new URL(window.location);
    url.searchParams.set(type, val);
    window.history.pushState({}, "", url);
}

export function filter(post_type, options, cb) {

    const filter_loading_animation = document.createElement('div');
    filter_loading_animation.classList.add('filter-loading-animation');
    // filter_loading_animation.innerHTML = `
    //     <div class="filter-loading-animation--main">
    //         <svg class="" width="284" height="284" viewBox="0 0 284 284" fill="none" xmlns="http://www.w3.org/2000/svg">
    //             <path class="t" d="M71.57 177.43L65.71 160.46H34.59L28.83 177.43H19.73L45 105.78H55.51L80.87 177.43H71.57ZM50.05 114.78L37.41 151.97H62.78L50.04 114.78H50.05Z" fill="white"/>
    //             <path class="t" d="M123.97 154.69H87.8001C87.8001 159.35 89.6101 164.4 92.7501 167.53C95.0701 169.85 98.2001 171.16 102.15 171.16C106.1 171.16 109.53 170.05 111.65 167.82C113.06 166.4 113.97 164.99 114.68 162.26H123.07C122.36 167.32 119.33 172.06 115.19 174.9C111.55 177.32 107.01 178.73 102.15 178.73C94.9701 178.73 89.1101 175.71 85.1701 171.05C80.9301 166.1 78.8101 159.33 78.8101 152.05C78.8101 145.89 79.9201 140.43 82.7501 135.68C86.3901 129.52 93.1601 124.97 102.05 124.97C108.62 124.97 113.87 127.5 117.61 131.54C121.75 136.09 124.18 142.66 124.08 149.52L123.98 154.67L123.97 154.69ZM112.15 136.91C110.03 134.07 106.6 132.26 102.04 132.26C92.7401 132.26 88.2001 139.84 87.9901 147.32H115.28C115.28 143.48 114.17 139.64 112.15 136.91Z" fill="white"/>
    //             <path class="t" d="M164.84 177.43L164.24 170.76C161.31 175.92 154.74 178.74 148.98 178.74C142.72 178.74 137.86 176.62 134.53 173.19C129.68 168.23 127.15 160.46 127.15 151.97C127.15 143.48 129.78 135.09 134.94 130.14C138.27 127 143.02 124.98 148.98 124.98C154.53 124.98 161.1 127.61 163.83 132.26V104.47H172.42V177.43H164.84ZM158.67 135.6C156.65 133.78 154.12 132.26 150.38 132.26C138.97 132.26 135.94 142.47 135.94 151.86C135.94 161.25 138.97 171.46 150.38 171.46C154.12 171.46 156.64 169.95 158.67 168.12C162.92 164.38 164.33 158.22 164.33 151.85C164.33 145.48 162.92 139.32 158.67 135.58V135.6Z" fill="white"/>
    //             <path class="t" d="M218.49 177.26L218.29 167.62V142.75C218.29 139.8 217.78 137.16 216.77 134.83C214.34 129.24 208.65 124.98 198.7 124.98C192.4 124.98 186.31 126.81 182.86 130.46C180.22 133.2 178.5 136.55 178.39 141.22H186.82C186.82 138.69 187.74 136.66 189.36 135.02C191.09 133.29 194.03 131.98 198.7 131.98C202.87 131.98 205.4 133 207.13 134.62C209.46 136.75 209.76 139.9 209.76 142.44V146.2L194.13 147.11C180.12 147.93 175.86 156.56 175.86 163.15C175.86 171.07 181.75 178.99 193.52 178.99C200.73 178.99 207.12 175.75 210.07 170.56H210.28L210.93 177.67H218.49V177.25V177.26ZM209.75 155.95C209.75 160.21 208.43 164.47 205.39 167.62C202.65 170.46 198.79 171.78 194.83 171.78C187.52 171.78 184.67 167.52 184.67 162.95C184.67 156.45 190.77 154.01 195.94 153.71L209.74 152.9V155.95H209.75Z" fill="white"/>
    //             <path class="t" d="M259.6 172.98C255.66 177.02 249.6 178.74 242.93 178.74C236.26 178.74 230.71 177.23 226.35 172.98C223.22 169.96 221.4 165.6 221.4 161.26H229.99C230.09 164.79 231.71 167.42 234.14 169.24C236.46 170.96 240.1 171.57 243.33 171.57C246.86 171.57 250.1 170.96 252.73 168.74C254.15 167.63 255.26 165.51 255.26 163.18C255.26 159.34 252.53 156.62 247.27 155.9C245.05 155.6 239.29 154.89 235.75 154.39C228.07 153.17 223.21 148.42 223.21 140.64C223.21 136.71 225.14 132.96 227.46 130.64C230.8 127.21 236.15 124.98 242.52 124.98C249.29 124.98 255.36 127.1 258.79 131.45C261.02 134.18 262.43 137.11 262.43 141.25H253.84C253.74 138.63 252.42 136.2 250.92 134.88C248.79 132.96 245.96 132.15 242.53 132.15C240.51 132.15 238.99 132.15 236.57 133.16C233.34 134.48 231.42 137.2 231.42 140.03C231.42 144.28 234.04 146.09 238.29 146.7C241.12 147.1 245.16 147.51 250.62 148.42C257.89 149.63 263.66 154.89 263.66 162.57C263.66 167.02 262.04 170.45 259.62 172.98H259.6Z" fill="white"/>
    //         </svg>
    //         <div class="_plus _1"><div></div><div></div></div>
    //         <div class="_plus _2"><div></div><div></div></div>
    //         <div class="_plus _3"><div></div><div></div></div>
    //         <div class="_plus _4"><div></div><div></div></div>
    //     </div>
    // `;
    document.body.append(filter_loading_animation);
    gsap.to(filter_loading_animation, { opacity: 0, duration: 0.3 });

    fetch(`?www_api=getCardItems`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(options),
    })
    .then((response) => response.json())
    .then((response) => {

        let old_items = document.querySelector("[js-part-items]");

        gsap.to(window, { duration: .35,
            scrollTo: {
                // y: old_items.offsetTop - document.querySelector('header').offsetHeight - 75,
                y: document.querySelector(".www-filter-v2").offsetTop - document.querySelector('header').offsetHeight,
                // offsetY: document.querySelector('header').offsetHeight + 100,
            }
        });

        const data_view = old_items.querySelector(".items[data-view]") ? old_items.querySelector("[data-view]").dataset.view : null;

        let new_items = document.createElement("div");
        new_items.innerHTML = response.items.trim();

        if (data_view) {
            new_items.querySelector(".items[data-view]").dataset.view = data_view;
        }

        old_items.parentNode.replaceChild(new_items.firstChild, old_items);

        

        gsap.to(filter_loading_animation, { 
            opacity: 0, 
            duration: 0.3,
            onComplete: () => {
                filter_loading_animation.remove();

                const fadeinBatch = document.querySelectorAll("[js-part-items] [js-scroll_fadein='batch']");
                if (fadeinBatch) {
                    ScrollTrigger.batch("[js-scroll_fadein='batch']", {
                        start: "top 90%",
                        invalidateOnRefresh: true,
                        // markers: true,
                        onEnter: (elements, triggers) => {
                            gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
                            // console.log(elements.length, "elements entered");
                        },
                        onLeaveBack: (elements, triggers) => {
                            gsap.to(elements, { opacity: 0, y: 40, stagger: 0.15 });
                            // console.log(elements.length, "elements leave back");
                        },
                    });
                }
                //fade in from bottom
                const fadeinBottom = document.querySelectorAll("[js-part-items] [js-scroll_fadein='bottom']");
                if (fadeinBottom) {
                    fadeinBottom.forEach((el, i) => {
                        ScrollTrigger.create({
                            trigger: el,
                            start: "top 90%",
                            invalidateOnRefresh: true,
                            // markers: true,
                            onEnter: () => {
                                gsap.to(el, { opacity: 1, y: 0 });
                                el.classList.add("fade-in");
                                // console.log(el, "elements entered");
                            },
                            onLeaveBack: () => {
                                gsap.to(el, { opacity: 0, y: 40 });
                                el.classList.remove("fade-in");
                                // console.log(el, "elements leave back");
                            },
                        });
                    });
                }

            }
        });

        

        
        // re-init scroll fade in
        // gsap.to(el_div, {
        //     duration: .3,
        //     opacity: 0,
        //     onComplete: () => {
        //         //fade in batch - from bottom
                

        //     }
        // })

        cb(response)
    })

}
